import { ShibUserListTranslation } from 'locales/de/pages/Users/shibUserList';

const en: ShibUserListTranslation = {
  uid: 'UID',
  entitlements: 'Entitlements',
  role: 'Role',
  actions: 'Actions',
  meta: 'Meta object',
  roles: 'Roles',
  communities: 'Communities',
  alerts: {
    loadUsersError: 'Users could not be loaded!',
    loadUserError: 'User could not be loaded!',
    loadUserNotFoundError: 'User could not be found!'
  }
};

export default en;
